import { ExternalLink } from "lucide-react";
import SEO from "@/components/SEO";

const SPOTIFY_ARTIST_ID = "3EYFamAYwkxnirfWB7IkBn";
const SPOTIFY_TRACK_FEELS_RIGHT = "6nm65fMeYE6UQVP1yxn4NQ";
const SPOTIFY_ALBUM_CONSCIOUS = "687AtMWKuI6cf91z1vV1UU";

const PLATFORMS = [
  {
    name: "Spotify",
    href: `https://open.spotify.com/artist/${SPOTIFY_ARTIST_ID}`,
    testId: "music-link-spotify",
  },
  {
    name: "Apple Music",
    href: "https://music.apple.com/us/artist/alekz/1715908465",
    testId: "music-link-apple",
  },
  {
    name: "SoundCloud",
    href: "https://linktr.ee/alekzsoto",
    testId: "music-link-soundcloud",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/alekzsoto",
    testId: "music-link-instagram",
  },
];

export default function Music() {
  return (
    <section
      className="relative min-h-screen pt-32 sm:pt-40 px-6 sm:px-10 lg:px-14 pb-24"
      data-testid="music-page"
    >
      <SEO
        path="/music"
        title="Music"
        description="Listen to ALEKZ — Alex Soto. Featuring the new single Feels Right and the album Conscious on Spotify, Apple Music and SoundCloud. Techno and hardgroove from New York."
      />
      <div className="max-w-5xl mx-auto">
        <h2
          className="font-display text-white leading-[0.95]"
          style={{ fontSize: "clamp(3rem, 9vw, 7rem)", letterSpacing: "-0.01em" }}
          data-testid="music-title"
        >
          Music
        </h2>

        <div className="mt-10 h-px bg-[var(--hairline-strong)] line-grow" />

        {/* Featured single — Feels Right */}
        <div className="mt-12 sm:mt-16">
          <p className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)] mb-5">
            Featured · Feels Right
          </p>
          <div
            className="relative w-full overflow-hidden rounded-md border border-[var(--hairline-strong)] bg-black"
            style={{ boxShadow: "var(--shadow-deep)" }}
          >
            <iframe
              data-testid="spotify-track-feels-right"
              title="Feels Right — ALEKZ"
              src={`https://open.spotify.com/embed/track/${SPOTIFY_TRACK_FEELS_RIGHT}?utm_source=generator&theme=0`}
              width="100%"
              height="152"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="eager"
              style={{ border: 0, display: "block" }}
            />
          </div>
        </div>

        {/* Featured album — Conscious */}
        <div className="mt-10">
          <p className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)] mb-5">
            Album · Conscious
          </p>
          <div
            className="relative w-full overflow-hidden rounded-md border border-[var(--hairline-strong)] bg-black"
            style={{ boxShadow: "var(--shadow-deep)" }}
          >
            <iframe
              data-testid="spotify-album-conscious"
              title="Conscious — ALEKZ"
              src={`https://open.spotify.com/embed/album/${SPOTIFY_ALBUM_CONSCIOUS}?utm_source=generator&theme=0`}
              width="100%"
              height="152"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="eager"
              style={{ border: 0, display: "block" }}
            />
          </div>
        </div>

        {/* Platforms grid */}
        <div className="mt-16">
          <p className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)] mb-6">
            Listen on
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[var(--hairline)]">
            {PLATFORMS.map((p) => (
              <li key={p.name} className="bg-black">
                <a
                  href={p.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={p.testId}
                  className="group flex items-center justify-between px-6 py-6 hover:bg-white/[0.03] transition-colors"
                >
                  <span className="font-display text-2xl sm:text-3xl text-white">
                    {p.name}
                  </span>
                  <ExternalLink className="w-4 h-4 text-[var(--silver-soft)] group-hover:text-white transition-colors" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
